import { render, staticRenderFns } from "./reciveandPostInfo.vue?vue&type=template&id=28c43efc&scoped=true"
import script from "./reciveandPostInfo.vue?vue&type=script&lang=js"
export * from "./reciveandPostInfo.vue?vue&type=script&lang=js"
import style0 from "./reciveandPostInfo.vue?vue&type=style&index=0&id=28c43efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c43efc",
  null
  
)

export default component.exports